export default __webpack_public_path__ + "static/media/type-light.4554c76f.svg";